import React from 'react'
import { Link, LinkProps } from 'react-router-dom'

export type RouterLinkProps = Omit<LinkProps, 'innerRef' | 'ref'>

export const RouterLink = React.forwardRef((props: RouterLinkProps, ref: React.Ref<any>) => (
  <Link innerRef={ref} {...props} />
))

RouterLink.displayName = 'RouterLink'
